import {create} from 'zustand'

const INITIAL_STATE = {
  snapshot: null,
  loading: false,
  loaded: false,
  error: null,
  refreshTick: 0,
}

export const useOnboardingStore = create((set, get) => ({
  ...INITIAL_STATE,

  setLoading: (loading) => set((state) => {
    if (state.loading === loading) return state
    return {loading}
  }),

  setSnapshot: (snapshot) => set(() => ({
    snapshot,
    loading: false,
    loaded: true,
    error: null,
  })),

  setError: (error) => set(() => ({
    snapshot: null,
    loading: false,
    loaded: true,
    error: typeof error === 'string' ? error : 'Failed to load onboarding snapshot',
  })),

  refresh: () => set((state) => ({
    refreshTick: state.refreshTick + 1,
  })),

  clear: () => {
    const refreshTick = get().refreshTick
    set(() => ({
      ...INITIAL_STATE,
      refreshTick,
    }))
  },
}))

export default useOnboardingStore
